import cx from "classnames";
import { useAtomValue } from "jotai";
import type { KeyboardEvent } from "react";
import { useEffect, useState } from "react";
import { canv } from "@/canv/global";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { decodeHtml } from "@/shared/lib/decodeHtml";
import { renamePresentation } from "../../lib/renamePresentation";
import type { SetActiveSubMenu } from "../../types";
import styles from "./PresentationRenameInput.module.css";

interface DocumentReNameInputProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function PresentationRenameInput({ setActiveSubMenu }: DocumentReNameInputProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("presentationName"));

    const [value, setValue] = useState(() => decodeHtml(options[0].value as string));

    useEffect(() => {
        setValue(decodeHtml(options[0].value as string));
    }, [options]);

    const handleInputFocus = () => {
        setActiveSubMenu(null);
        canv.appInterface.inputFocused = 1;
    };

    const handleInputBlur = () => {
        canv.appInterface.inputFocused = 0;
        renamePresentation(value.slice(0, 255), canv);
    };

    const handleInputKeydown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            event.currentTarget.blur();
        }
    };

    return (
        <input
            className={cx(styles.input, "presentationNameInputField")}
            type="text"
            maxLength={255}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onKeyDown={handleInputKeydown}
        />
    );
}
